<div class="chart-container">
    <ngx-charts-advanced-pie-chart [scheme]="dashTema" [results]="results" [gradient]="gradient" (select)="onSelect($event)" style="fill: grey;">
    </ngx-charts-advanced-pie-chart>
</div>